import { useEffect, useState } from "react";

import ModalBottom from "../../../../UI/ModalBottom";
import WalletActionButtonAddBalanceModalTitle from "./Title";
import WalletActionButtonAddBalanceModalBalance from "./Balance";
import WalletActionButtonAddBalanceModalSelectPrice from "./SelectPrice";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { paymentToWallet } from "../../../../../redux/action/wallet/action";
import { SET_ERROR_WALLET } from "../../../../../redux/action/wallet/type";
import { ReactSVG } from "react-svg";
import { useNavigate } from "react-router-dom";

const WalletActionButtonAddBalanceModal = (props) => {
  const dispatch = useDispatch();
  const walletError = useSelector((state) => state.wallet.error);
  const paymentLoading = useSelector((state) => state.wallet.paymentLoading);

  const [price, setPrice] = useState("");

  const navigate = useNavigate();

  const [cookies] = useCookies(["authToken"]);

  useEffect(() => {
    return () => {
      if (document.body.classList.contains("modal-opened"))
        document.body.classList.remove("modal-opened");

      if (props.shouldIncreasePrice) props.OnSetShouldIncreasePrice(null);
    };
  }, []);

  const pay = async () => {
    let findItems = null;
    if (price === "" || price === null) {
      if (!walletError) {
        // show error
        dispatch({
          type: SET_ERROR_WALLET,
          payload: "یک پلن شارژ راانتخاب کنید",
        });

        setTimeout(() => {
          // destroy error
          dispatch({
            type: SET_ERROR_WALLET,
            payload: null,
          });
        }, 2000);
      }
      return;
    } else {
      findItems = props.walletPlanItems.find(
        (items) => items.real_price === price,
      );
    }

    const data = await dispatch(
      await paymentToWallet(price, cookies.authToken, findItems.id),
    );

    if (data) {
      const developerPayload = `userId=${data?.urls[0].user_id}&plan_id=${findItems.id}&type=${0}&amount=${price}&invoice_id=${data?.urls[0].invoice_id}`;

      // send user to that page.
      navigate("/payment-geteway", {
        state: {
          urls: data?.urls,
          bazaar: {
            last_purchase_date: findItems.last_purchase_date,
            last_purchase_token: findItems.last_purchase_token,
            developerPayload,
            transaction_id: data?.urls[0].transaction_id,
            plan_code: findItems?.plan_code,
            wallet: true,
          },
          wallet: {
            price: price,
          },
        },
      });

      setPrice("");

      props.onSetShowPayModal(false);
      props.onSetShowingPayModal(false);
    }
  };

  return (
    <ModalBottom
      show={props.showPayModal}
      onSetShow={props.onSetShowPayModal}
      className="overflow-y-hidden no-scrollbar h-fit min-h-[300px]"
      showing={props.showingPayModal}
      onSetShowing={props.onSetShowingPayModal}
    >
      <WalletActionButtonAddBalanceModalTitle props={props} />

      <div className="mt-4 flex flex-col w-full h-full">
        <WalletActionButtonAddBalanceModalBalance />

        <WalletActionButtonAddBalanceModalSelectPrice
          walletPlanItems={props.walletPlanItems}
          price={price}
          onSetPrice={setPrice}
        />

        {/* <WalletActionButtonAddBalanceModalPriceField 
                    price={price}
                    onSetPrice={setPrice}
                    shouldIncreasePrice={props.shouldIncreasePrice}
                /> */}

        <button
          onClick={pay}
          disabled={paymentLoading}
          className="btn disabled:opacity-90 w-full md:mt-14 mt-12 h-12 mb-1 outline font-medium rounded-xl outline-[3px] outline-primary/20"
        >
          {!paymentLoading ? (
            "پرداخت"
          ) : (
            <ReactSVG
              className="w-12"
              src={`${process.env.PUBLIC_URL}/assets/images/icons/loading-dot.svg`}
            />
          )}
        </button>
      </div>
    </ModalBottom>
  );
};

export default WalletActionButtonAddBalanceModal;
